<template>
  <WizardContainer
    width="792px"
    height="624px"
  >
    <WizardContent>
      <h4 class="mt-6 mb-8">
        Great news! Your Demo is ready.
      </h4>
      <p class="p3 mb-9">
        To view your demo and begin editing jobs, please first create a password below.
      </p>
      <v-form
        ref="form"
        v-model="valid"
        class="form"
        @submit.prevent="submitForm"
      >
        <DpplTextField
          v-model="password"
          label="Set Password"
          :rules="passwordRules"
          type="password"
          autocomplete="off"
          validate-on="blur"
          data-sentry-mask
        />
        <DpplTextField
          v-model="confirmPassword"
          class="mb-3"
          label="Confirm Password"
          :rules="confirmPasswordRules"
          type="password"
          autocomplete="off"
          validate-on="blur"
          data-sentry-mask
        />
        <DpplSignupFormButton
          type="submit"
          block
          :loading="loading"
        >
          Submit
        </DpplSignupFormButton>
      </v-form>
    </WizardContent>
  </WizardContainer>
</template>

<script>
import WizardContainer from '@/components/shared/WizardContainer.vue';
import WizardContent from '@/components/shared/WizardContent.vue';
import { signupSetPassword } from '@/api/signup';
import validation from '@/helpers/validation';
import DpplTextField from '@/components/datapeople/DpplTextField.vue';
import DpplSignupFormButton from '@/components/datapeople/DpplSignupFormButton.vue';
import { mapActions } from 'pinia';
import { useWizard } from '@/stores/wizard/wizard';

export default {
  name: 'DemoReady',
  components: {
    WizardContainer,
    WizardContent,
    DpplTextField,
    DpplSignupFormButton,
  },
  emits: ['track-page-load'],
  data() {
    return {
      passwordResetToken: this.$route.query.key || null,
      password: '',
      confirmPassword: '',
      passwordRules: validation.passwordRules(),
      confirmPasswordRules: [(v) => v === this.password || 'Passwords must match'],
      valid: false,
      loading: false,
    };
  },
  async created() {
    if (!this.passwordResetToken) {
      this.$router.push({
        name: 'signup',
      });
    }
  },
  beforeCreate() {
    this.$emit('track-page-load', { page: 'Demo Ready' });
  },
  methods: {
    ...mapActions(useWizard, ['updateFlash']),
    async submitForm() {
      try {
        const formValidateResult = await this.$refs.form.validate();
        if (formValidateResult.valid) {
          this.loading = true;
          const responseJSON = await signupSetPassword({
            passwordResetToken: this.passwordResetToken,
            password: this.password,
            confirmPassword: this.confirmPassword,
          });
          if (responseJSON.success === true) {
            this.$router.replace({ name: 'root' });
          }
        }
      } catch (e) {
        this.updateFlash({ message: 'Something went wrong' });
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.form {
  width: 100%;
}
</style>
